import { SummaryStatBadge } from "../../../utils/integrationConfigData";

interface StatsCardProps {
  title: string;
  badge: SummaryStatBadge;
  icon: string;
  detail?: string;
}

const StatsCard = ({ title, badge, icon, detail }: StatsCardProps) => {
  const summaryText =
    badge?.value != null && badge.value !== ""
      ? `${badge.value} ${badge.text}`.trim()
      : badge?.text;

  return (
    <article className="ic-overview-stat">
      <div className="ic-overview-stat-top">
        <span className="ic-overview-stat-icon ic-stats-icon">
          <i className={icon} aria-hidden="true"></i>
        </span>
        <div className="ic-overview-stat-heading">
          <h3 className="ic-overview-stat-title">{title}</h3>
          {summaryText && (
            <p className="ic-overview-stat-summary">{summaryText}</p>
          )}
        </div>
      </div>

      {detail && (
        <p className="ic-overview-stat-detail" title={detail}>
          {detail}
        </p>
      )}
    </article>
  );
};

export default StatsCard;
